module.exports = __webpack_public_path__ + "img/brown-btn.b573fbd1.svg";